export const PRINTINGS_OPERATION_PERMISSIONS = [
  'view_orders',
  'manage_orders',
  'review_orders',
  'manage_previews',
];

export const getEffectivePermissions = (permissions) => {
  const effective = new Set(
    Array.isArray(permissions)
      ? permissions.filter((permission) => typeof permission === 'string')
      : []
  );

  if (effective.has('manage_printings')) {
    PRINTINGS_OPERATION_PERMISSIONS.forEach((permission) => {
      effective.add(permission);
    });
  }

  return [...effective];
};

export const withEffectivePermissions = (user) => (
  user
    ? {
        ...user,
        permissions: getEffectivePermissions(user.permissions),
      }
    : user
);
